import { TApplicationState } from "../rootReducer";
import { RETRY_LATER } from "./errorPopupTypes";

export const isRetryPopup = (state : TApplicationState ) => {
  return state.usersAnketa.hasErrorPopup.error === RETRY_LATER;
}